import type { Token } from 'src/types/auth';
import { AxiosResponse } from 'axios';
import { createAxios } from '../factories/axios-factory';

const backend = createAxios(process.env.DealersApiUrl!);

const authenticationService = {
	authenticateDealer(username: string, password: string): Promise<Token> {
		return new Promise((resolve, reject) => {
			const authCredentials = {
				password,
				username: username
			};
			backend
				.post('/auth/login', authCredentials)
				.then((response: AxiosResponse) => {
					resolve(response.data as Token);
				})
				.catch((error: any) => {
					window.console.error(error.message);
					reject(error);
				});
		});
	},
	forgotPassword(email: string) {
		return new Promise<string>((resolve, reject) => {
			const authCredentials = {
				email
			};
			backend
				.post('/auth/password-forgot', authCredentials)
				.then((response: AxiosResponse) => {
					if (response.status === 200) {
						resolve(response.data.passwordResetGuid);
					}
					reject(false);
				})
				.catch((error: any) => {
					window.console.error(error.message);
					reject(error);
				});
		});
	},
	resetPassword(token: string, password: string) {
		return new Promise<boolean>((resolve, reject) => {
			const authCredentials = {
				passwordResetGuid: token,
				password
			};
			backend
				.post('/auth/password-reset', authCredentials)
				.then((response: AxiosResponse) => {
					if (response.status === 200) {
						resolve(true);
					}
					reject(false);
				})
				.catch((error: any) => {
					window.console.error(error.message);
					reject(error);
				});
		});
	},
	isFeatureEnabled(name: string) {
		return new Promise<boolean>((resolve, reject) => {
			backend
				.get(`/features/is-enabled/${name}`)
				.then((response: AxiosResponse) => {
					if (response.status === 200) {
						resolve(true);
					}
					resolve(false);
				})
				.catch((error: any) => {
					window.console.error(error.message);
					reject(error);
				});
		});
	},
	registerDealer(request: { firstName: string; lastName: string; email: string; phoneNumber: string; dealershipName: string }) {
		return new Promise<boolean>((resolve, reject) => {
			backend
				.post('/auth/register', request)
				.then((response: AxiosResponse) => {
					if (response.status === 200) {
						resolve(true);
					}
					reject(false);
				})
				.catch((error: any) => {
					window.console.error(error.message);
					reject(error);
				});
		});
	}
};

export default authenticationService;
